export const PersianNum = (num: number) => {
  try {
    return new Intl.NumberFormat("fa-IR").format(num);
  } catch (error) {
    return "";
  }
};
